import createIcon from '../../createIcon';

/**
 * @component @name Policy
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEgNUwxMiAxTDMgNVYxMUMzIDE2LjU1IDYuODQgMjEuNzQgMTIgMjNDMTQuMyAyMi40NCAxNi4zMyAyMS4xIDE3Ljg4IDE5LjI5TDE0Ljc2IDE2LjE3QzEyLjgyIDE3LjQ2IDEwLjE4IDE3LjI0IDguNDcgMTUuNTNDNi41MiAxMy41OCA2LjUyIDEwLjQxIDguNDcgOC40NkMxMC40MiA2LjUxIDEzLjU5IDYuNTEgMTUuNTQgOC40NkMxNy4yNSAxMC4xNyAxNy40NiAxMi44MSAxNi4xOCAxNC43NUwxOS4wOCAxNy42NUMyMC4yOSAxNS42OSAyMSAxMy4zOCAyMSAxMVY1WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTEyIDE1QzEzLjY1NjkgMTUgMTUgMTMuNjU2OSAxNSAxMkMxNSAxMC4zNDMxIDEzLjY1NjkgOSAxMiA5QzEwLjM0MzEgOSA5IDEwLjM0MzEgOSAxMkM5IDEzLjY1NjkgMTAuMzQzMSAxNSAxMiAxNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Policy = createIcon('Policy', [
  [
    'path',
    {
      d: 'M21 5L12 1L3 5V11C3 16.55 6.84 21.74 12 23C14.3 22.44 16.33 21.1 17.88 19.29L14.76 16.17C12.82 17.46 10.18 17.24 8.47 15.53C6.52 13.58 6.52 10.41 8.47 8.46C10.42 6.51 13.59 6.51 15.54 8.46C17.25 10.17 17.46 12.81 16.18 14.75L19.08 17.65C20.29 15.69 21 13.38 21 11V5Z',
      key: '1eb8ee',
    },
  ],
  [
    'path',
    {
      d: 'M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z',
      key: '1phkua',
    },
  ],
]);

export default Policy;
